import type { ReactElement } from "react";

export function ErrorIcon(): ReactElement {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4909 33.7964C24.9789 33.7964 25.3909 33.6314 25.7269 33.3014C26.0629 32.9714 26.2309 32.5624 26.2309 32.0744C26.2309 31.5867 26.0657 31.1749 25.7354 30.8389C25.4054 30.5029 24.9966 30.3349 24.5089 30.3349C24.0209 30.3349 23.6089 30.4999 23.2729 30.8299C22.9369 31.1602 22.7689 31.5692 22.7689 32.0569C22.7689 32.5449 22.9341 32.9569 23.2644 33.2929C23.5944 33.6286 24.0032 33.7964 24.4909 33.7964ZM22.8499 26.4734H26.1499V14.2194H22.8499V26.4734ZM17.1459 41.6004L6.8999 31.3724V16.6464L17.1279 6.40039H31.8539L42.0999 16.6284V31.3544L31.8719 41.6004H17.1459Z"
        fill="#F02D06"
      />
    </svg>
  );
}
